var marketSelector = {
	selectionLabel: "Select a Market"
};
var en = {
	marketSelector: marketSelector
};

export { en as default, marketSelector };
